<template>
  <div class="rating">
    <i v-for="i in 5" class="icon icon-star" :class="{ marked: i <= rating }"></i>
  </div>
</template>

<script setup>
defineProps({ rating: Number })
</script>

<style lang="scss" scoped>
.rating {
  display: flex;
  flex-direction: row;
  gap: 4px;
}

.icon {
  color: $gray;
  font-size: 22px;

  &.marked {
    color: $yellow;
  }
}
</style>
